import { Field } from 'formik'
import styled, { css } from 'styled-components'

import { colors } from '../../styles/colors'
import dimensions from '../../styles/dimensions'

const { componentHeight } = dimensions

interface IButtonProps {
  disabled?: boolean
}

export const StyledInput = styled(Field)<IButtonProps>`
  width: 100%;
  height: ${componentHeight.large}px;

  border: 1px solid ${colors.grayLight};
  border-radius: 4px;

  padding: 12px 10px;

  font-weight: 400;
  font-size: 12px;

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      background-color: ${colors.gray5};
      color: ${colors.gray4};
    `}
`

export const StyledError = styled.p`
  width: 100%;
  color: red;
  font-weight: 400;
  font-size: 12px;
  margin-top: 5px;
`

export const Label = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 14px;
  font-weight: normal;
  color: ${colors.blue};
`

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${dimensions.spaces.small}px;
`

export const HelperMessage = styled.span`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 14px;
  font-weight: normal;
  margin-left: 5px;
  color: ${colors.red};
`
